@if (chatOpened === false) {
<div id="ai-chat-bubble" (click)="onChatBubbleClick()">
  <mat-icon svgIcon="ai-chat-icon"></mat-icon>
</div>
} @if ((loading$ | async) && chatOpened === true) {
<div class="loading">
  <mat-spinner color="accent"></mat-spinner>
</div>
} @if (chatOpened === true) {
<div id="ai-chat-content">
  <header class="chat-header">
    <div><mat-icon class="ai-chat-icon" svgIcon="ai-chat-icon"></mat-icon> AI Assistant</div>
    <div>
      <button class="chat-action-btn" mat-icon-button (click)="toggleChatSize()">
        <mat-icon [svgIcon]="isMaximized ? 'icon-shrink' : 'icon-expand'"></mat-icon>
      </button>
      <button class="chat-action-btn" mat-icon-button (click)="minimizeChat()">
        <mat-icon class="chat-icon" svgIcon="icon-minimize"></mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Options">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="closeSession(true)">
          <mat-icon>autorenew</mat-icon>
          <span>Reset</span>
        </button>
        <button mat-menu-item (click)="closeSession(false)">
          <mat-icon>playlist_remove</mat-icon>
          <span>Close</span>
        </button>
      </mat-menu>
    </div>
  </header>
  <div class="ai-chat-inner-content">
    <div class="chat-messages" #scrollMe [scrollTop]="scrollMe.scrollHeight">
      @for (message of (messages$ | async); track message) {
      <div class="messages">
        <app-chat-message [message]="message"></app-chat-message>
      </div>
      } @if ((messageLoading$ | async)) {
      <div class="message-loading">Thinking<span class="loader">...</span></div>
      } @if ((error$ | async); as error) {
      <app-message
        [message]="error.message"
        [title]="''"
        [type]="'warning'"
        [buttonLabel]="'Create new session'"
        [callbackFunction]="retryCallbackFn"
      >
      </app-message>
      } @if (!(messages$ | async)?.length) {
      <div class="first-message">
        <p>Hi, {{ data.userName }}</p>
        <p>What can I do for you today?</p>
      </div>
      }
    </div>
    <div class="chat-input">
      <mat-form-field appearance="outline">
        <textarea
          matInput
          [formControl]="messageTextArea"
          placeholder="Type your message..."
          cdkTextareaAutosize
          #autosize="cdkTextareaAutosize"
          [cdkAutosizeMinRows]="1"
          [cdkAutosizeMaxRows]="5"
          (keydown.enter)="$event.preventDefault();sendMessage()"
        ></textarea>
        <mat-icon matSuffix (click)="sendMessage()" svgIcon="icon-send"></mat-icon>
      </mat-form-field>
    </div>
  </div>
</div>
}
